import { useEffect, useState } from "react";
import { Copy, Clock, CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { fmtTL } from "@/lib/api";

export default function MyNumbers() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/activations").then(({ data }) => { setRows(data.activations || []); setLoading(false); });
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, []);

  const statusInfo = (s) => ({
    waiting: ["Bekleniyor", "bg-amber-500/15 text-amber-500", Clock],
    received: ["Kod Geldi", "bg-emerald-500/15 text-emerald-500", CheckCircle2],
    done: ["Tamamlandı", "bg-emerald-500/15 text-emerald-500", CheckCircle2],
    cancelled: ["İptal/İade", "bg-red-500/15 text-red-500", XCircle],
  }[s] || [s, "bg-panel-input", Clock]);

  return (
    <div>
      <h1 className="font-head text-3xl font-bold tracking-tight">Numaralarım</h1>
      <p className="text-panel-secondary text-sm mt-1 mb-5">Aldığın numaralar ve onay kodların.</p>
      {loading && <div className="flex justify-center py-10"><Loader2 className="animate-spin text-brand-500" /></div>}
      <div className="space-y-3">
        {rows.map((a) => {
          const [lbl, cls, Icon] = statusInfo(a.status);
          return (
            <div key={a.id} className="card p-4" data-testid={`number-row-${a.id}`}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 min-w-0">
                  <img src={a.icon} alt="" className="h-10 w-10 rounded-xl bg-white p-1 object-contain shrink-0" onError={(e) => (e.target.style.visibility = "hidden")} />
                  <div className="min-w-0">
                    <div className="font-semibold text-sm truncate">{a.service_name} · {a.country_name}</div>
                    <div className="font-mono text-sm flex items-center gap-1.5">
                      +{a.phone}
                      <button onClick={() => { navigator.clipboard.writeText(a.phone); toast.success("Kopyalandı"); }} className="text-brand-500"><Copy size={13} /></button>
                    </div>
                  </div>
                </div>
                <span className={`text-xs font-semibold rounded-full px-2.5 py-1 flex items-center gap-1 shrink-0 ${cls}`}><Icon size={12} /> {lbl}</span>
              </div>
              {a.code && (
                <div className="mt-3 rounded-xl bg-emerald-500/10 border border-emerald-500/20 p-3 flex items-center justify-between">
                  <span className="text-xs text-panel-muted">Onay Kodu</span>
                  <span className="font-mono text-lg font-bold text-emerald-500 flex items-center gap-2">
                    {a.code}
                    <button onClick={() => { navigator.clipboard.writeText(a.code); toast.success("Kopyalandı"); }} className="text-brand-500"><Copy size={15} /></button>
                  </span>
                </div>
              )}
              <div className="mt-2 flex items-center justify-between text-xs text-panel-muted">
                <span>{fmtTL(a.price)}</span>
                {a.status === "waiting" && <span>{Math.floor(a.seconds_left / 60)} dk kaldı</span>}
              </div>
            </div>
          );
        })}
        {!loading && rows.length === 0 && <div className="text-center text-panel-muted py-12 text-sm">Henüz numara almadın. Satın Al sekmesinden başla.</div>}
      </div>
    </div>
  );
}
